import Breadcrumb from '@/components/feature/Breadcrumb';

export default function ComicsHeader() {
  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '漫画库' }]} />
        <h1 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">漫画库</h1>
        <p className="mt-3 max-w-2xl text-foreground-600 md:text-lg">
          浏览并按分类筛选连载漫画，把喜欢的作品收进追更清单，开启连载更新提醒。
        </p>
      </div>
    </section>
  );
}